import React from "react";
import { useSelector } from "react-redux";

import { fetchScoreSgdPostsAsync } from "../../../../../redux/thunk/Posts";
import SpeakingScoreList from "../../../../../components/Backend/Admin/ScoreList/SpeakingScoreList";

function RepeatSentence() {
  const { scoreSgdPosts, scoreSgdStatus } = useSelector((state) => state.posts);
  console.log(scoreSgdPosts, scoreSgdStatus);

  return (
    <>
      <SpeakingScoreList
        category="sgd"
        title="Summarize Group Discussion"
        scorePosts={scoreSgdPosts}
        scoreStatus={scoreSgdStatus}
        fetchScoresAsync={fetchScoreSgdPostsAsync}
      />
    </>
  );
}

export default RepeatSentence;
